import VideoSrc from "../images/promo-preview.mp4"
import CoverSrc from "../images/promo-video-cover.jpg"

export default {
  label: "Video",
  url: "https://www.youtube.com/playlist?list=PLqxr4aBubkPZV0QhospahIbxwFiIWJdCb",
  cover: {
    videoSrc: VideoSrc,
    coverSrc: CoverSrc,
  },
}
